var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15 3.35742 11.6426 0 7.5 0C3.35742 0 0 3.35742 0 7.5C0 11.6426 3.35742 15 7.5 15C7.54395 15 7.58789 15 7.63184 14.9971V9.16113H6.02051V7.2832H7.63184V5.90039C7.63184 4.29785 8.61035 3.4248 10.04 3.4248C10.7256 3.4248 11.3145 3.47461 11.4844 3.49805V5.17383H10.5C9.72363 5.17383 9.57129 5.54297 9.57129 6.08496V7.28027H11.4316L11.1885 9.1582H9.57129V14.71C12.7061 13.8105 15 10.9248 15 7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b5064c97c9e573944ea4e6dd055f6ee0.svg";
export { ForwardRef as ReactComponent };